
import { logger } from "@/services/LoggingService";
import { toast } from "sonner";
import { 
  IMAGE_PATHS, 
  FILE_NAMES,
  validateImageUrl,
  uploadFromUrl,
  StorageError 
} from '@/utils/image-storage';

const COMPONENT = 'UrlUploadHandler';

interface UrlUploadProps {
  companyId: string;
  logoUrl: string;
  onSuccess: (publicUrl: string) => Promise<void>;
  setIsUploading: (isUploading: boolean) => void;
}

export async function handleUrlUpload({
  companyId,
  logoUrl,
  onSuccess,
  setIsUploading
}: UrlUploadProps): Promise<boolean> {
  if (!logoUrl.trim()) {
    toast.error("Please enter a valid logo URL");
    return false;
  }

  try {
    logger.info(COMPONENT, 'Starting URL upload', {
      companyId,
      logoUrl
    });

    setIsUploading(true);
    validateImageUrl(logoUrl);
    
    const publicUrl = await uploadFromUrl(
      IMAGE_PATHS.COMPANY(companyId),
      FILE_NAMES.COMPANY_LOGO,
      logoUrl,
      { upsert: true }
    );

    await onSuccess(publicUrl);

    logger.info(COMPONENT, 'URL upload successful', {
      companyId,
      publicUrl
    });

    toast.success("Logo uploaded successfully");
    return true;
  } catch (error: any) {
    logger.error(COMPONENT, 'URL upload failed', {
      error: error.message,
      details: error instanceof StorageError ? error.details : error
    });
    
    toast.error(error.message || "Failed to update logo URL");
    return false;
  } finally {
    setIsUploading(false);
  }
}
